import { formatCurrencyINR } from "@utils/numberFormatter";

export const chargesData = (priceBreakup: any) => {
  return [
    {
      label: "Ex-showroom price",
      value: getValue(priceBreakup.price.price_breakup, "ex_showroom"),
    },
    {
      label: "Registration amount",
      value: getValue(priceBreakup.price.price_breakup, "registration_amount"),
    },
    {
      label: "Dealer insurance premium",
      value: getValue(
        priceBreakup.price.price_breakup,
        "dealer_insurance_premium"
      ),
    },
    {
      label: "Tax",
      value: getValue(
        priceBreakup.price.price_breakup,
        "tax_collected_at_source"
      ),
    },
    {
      label: "Hypothecation",
      value: getValue(
        priceBreakup.price.price_breakup,
        "hypothecation_charges"
      ),
    },
    {
      label: "FASTag",
      value: getValue(priceBreakup.price.price_breakup, "fast_tag"),
    },
  ];
};
const getValue = (breakUp: any, value: string): string | null =>
  breakUp[value] ? formatCurrencyINR(breakUp[value]) : null;
